/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderDataDto
 */
export interface OrderDataDto {
    /**
     * 
     * @type {string}
     * @memberof OrderDataDto
     */
    externalId: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDataDto
     */
    companyName: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDataDto
     */
    description: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderDataDto
     */
    total?: number;
    /**
     * 
     * @type {Date}
     * @memberof OrderDataDto
     */
    date?: Date;
}

/**
 * Check if a given object implements the OrderDataDto interface.
 */
export function instanceOfOrderDataDto(value: object): value is OrderDataDto {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function OrderDataDtoFromJSON(json: any): OrderDataDto {
    return OrderDataDtoFromJSONTyped(json, false);
}

export function OrderDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'companyName': json['companyName'],
        'description': json['description'],
        'total': json['total'] == null ? undefined : json['total'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
    };
}

export function OrderDataDtoToJSON(json: any): OrderDataDto {
    return OrderDataDtoToJSONTyped(json, false);
}

export function OrderDataDtoToJSONTyped(value?: OrderDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'companyName': value['companyName'],
        'description': value['description'],
        'total': value['total'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString(),
    };
}

